const Fonts = [
  { fontFamily: 'Poppins, sans-serif', name: 'Poppins', src: require('./assets/typeface/Poppins.png') },
  { fontFamily: 'Chillax-Regular, sans-serif', name: 'Chillax', src: require('./assets/typeface/Chillax.png') },
  { fontFamily: 'Satoshi, sans-serif', name: 'Satoshi', src: require('./assets/typeface/Satoshi.png') },
  { fontFamily: 'Nippo-Medium, sans-serif', name: 'Nippo', src: require('./assets/typeface/Nippo.png') },
  { fontFamily: 'Anton, sans-serif', name: 'Anton', src: require('./assets/typeface/Anton.png') },
  { fontFamily: 'Magilio, cursive', name: 'Magilio', src: require('./assets/typeface/Magilio.png') }
];

export default Fonts;